// extracted by mini-css-extract-plugin
export var bodySections = "_c9-8";
export var gray = "_c9-7";
export var green = "_c9-4";
export var iconContainer = "_c9-9";
export var iconWidgetContainer = "_c9-1";
export var phoneIcon = "_c9-2";
export var red = "_c9-5";
export var statusDot = "_c9-3";
export var widgetContainer = "_c9-0";
export var yellow = "_c9-6";